/* ============================================================
   éclat — advertorial behaviour  (eclat-new namespace)

   Identical logic to the original inline script. Every selector,
   id, data attribute and global is namespaced so this file shares
   nothing with the previous implementation: both versions can run
   on the same page without touching each other.
   ============================================================ */
(function () {
  'use strict';

  /* the snippet is rendered by every section — only boot once */
  if (window.__eclatNewBooted) return;
  window.__eclatNewBooted = true;

  /* ---------- countdown (identical maths to the original) ---------- */
  function pad(n) { return String(n).padStart(2, '0'); }

  function left() {
    var H = (typeof window.ECLAT_NEW_DEADLINE_HOUR === 'number') ? window.ECLAT_NEW_DEADLINE_HOUR : 23;
    var M = (typeof window.ECLAT_NEW_DEADLINE_MIN === 'number') ? window.ECLAT_NEW_DEADLINE_MIN : 59;
    var n = new Date(), e = new Date(n.getFullYear(), n.getMonth(), n.getDate(), H, M, 0);
    if (e <= n) e.setDate(e.getDate() + 1);
    var t = Math.floor((e - n) / 1000);
    return { h: pad(Math.floor(t / 3600)), m: pad(Math.floor(t % 3600 / 60)), s: pad(t % 60) };
  }

  function paint() {
    var r = left();
    document.querySelectorAll('.eclat-new [data-eclat-new-u]').forEach(function (el) {
      el.textContent = r[el.dataset.eclatNewU];
    });
    var t = r.h + ':' + r.m + ':' + r.s;
    document.querySelectorAll('.eclat-new [data-eclat-new-tick]').forEach(function (el) {
      el.textContent = t;
    });
  }

  /* ---------- product shelf: arrows + filters ---------- */
  function initShelf(root) {
    var shelf = root.querySelector('.eclat-new-shelf');
    if (!shelf || shelf.dataset.eclatNewInit === '1') return;
    shelf.dataset.eclatNewInit = '1';

    var prev = root.querySelector('.eclat-new-snav.eclat-new-prev');
    var next = root.querySelector('.eclat-new-snav.eclat-new-next');
    var f = root.querySelectorAll('.eclat-new-filters button');
    var p = root.querySelectorAll('.eclat-new-shelf .eclat-new-prod');

    function arrows() {
      if (!prev || !next) return;
      var max = shelf.scrollWidth - shelf.clientWidth - 2;
      prev.disabled = shelf.scrollLeft <= 2;
      next.disabled = shelf.scrollLeft >= max;
    }
    function step(dir) {
      var card = shelf.querySelector('.eclat-new-prod:not([hidden])');
      var w = card ? card.getBoundingClientRect().width + 20 : 276;
      var per = Math.max(1, Math.round(shelf.clientWidth / w));
      shelf.scrollBy({ left: dir * w * per, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    shelf.addEventListener('scroll', arrows, { passive: true });
    window.addEventListener('resize', arrows);
    arrows();

    f.forEach(function (b) {
      b.addEventListener('click', function () {
        f.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        b.setAttribute('aria-selected', 'true');
        var key = b.dataset.eclatNewF;
        p.forEach(function (c) {
          var show = (key === 'all' || c.dataset.eclatNewCat.split(' ').indexOf(key) > -1);
          c.hidden = !show;
        });
        shelf.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(arrows, 320);
      });
    });
  }

  /* ---------- bundle selector in the buy box ---------- */
  function initBundles(root) {
    var wrap = root.querySelector('.eclat-new-bundles');
    if (!wrap || wrap.dataset.eclatNewInit === '1') return;
    wrap.dataset.eclatNewInit = '1';

    var bcards = wrap.querySelectorAll('.eclat-new-bcard');
    var bcta = root.querySelector('[data-eclat-new-bcta]') || root.querySelector('#eclat-new-bcta');

    function pick(card) {
      bcards.forEach(function (c) {
        c.classList.remove('eclat-new-on');
        var i = c.querySelector('input');
        if (i) i.checked = false;
      });
      card.classList.add('eclat-new-on');
      var inp = card.querySelector('input');
      if (inp) {
        inp.checked = true;
        if (bcta && inp.dataset.eclatNewUrl) bcta.href = inp.dataset.eclatNewUrl;
      }
    }

    bcards.forEach(function (c) {
      c.addEventListener('click', function () { pick(c); });
      var i = c.querySelector('input');
      if (i) i.addEventListener('change', function () { pick(c); });
    });

    var sel = wrap.querySelector('.eclat-new-bcard.eclat-new-on');
    if (sel && bcta) {
      var si = sel.querySelector('input');
      if (si && si.dataset.eclatNewUrl) bcta.href = si.dataset.eclatNewUrl;
    }
  }

  /* ---------- sticky bar + reading progress ---------- */
  function initSticky() {
    if (window.__eclatNewStickyBound) { onScroll(); return; }
    window.__eclatNewStickyBound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function onScroll() {
    var s = document.querySelector('.eclat-new .eclat-new-sticky');
    var g = document.querySelector('.eclat-new #eclat-new-prog');
    if (s) {
      var at = parseInt(s.dataset.eclatNewAt || '900', 10);
      s.classList.toggle('eclat-new-on', window.scrollY > at);
    }
    if (g) {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      g.style.width = (h > 0 ? window.scrollY / h * 100 : 0) + '%';
    }
  }

  /* ---------- boot ---------- */
  function init(scope) {
    var root = scope || document;
    (root.matches && root.matches('.eclat-new') ? [root] : Array.prototype.slice.call(root.querySelectorAll('.eclat-new')))
      .forEach(function (el) { initShelf(el); initBundles(el); });
    initSticky();
    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  if (!window.__eclatNewTimer) window.__eclatNewTimer = setInterval(paint, 1000);

  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
  document.addEventListener('shopify:section:unload', function () { onScroll(); });
})();
